var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNotificationWithBadgeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,25c0,0.5512695-0.4482422,1-1,1H3c-0.5517578,0-1-0.4487305-1-1V7c0-0.5512695,0.4482422-1,1-1h19V4H3 C1.3457031,4,0,5.3457031,0,7v18c0,1.6542969,1.3457031,3,3,3h24c1.6542969,0,3-1.3457031,3-3V12h-2V25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,2c-2.2060547,0-4,1.7944336-4,4s1.7939453,4,4,4s4-1.7944336,4-4S30.2060547,2,28,2z M28,8 c-1.1025391,0-2-0.8969727-2-2s0.8974609-2,2-2s2,0.8969727,2,2S29.1025391,8,28,8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    width: 10,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotificationWithBadgeSmall);
export default __webpack_public_path__ + "static/media/new-notification-with-badge--small.a14ad61741f44fc2777783713e3e4d70.svg";
export { ForwardRef as ReactComponent };